import type { Artifact } from '../artifacts/interface';
import { deserialize, fetchWrapper } from '../fetch';
import type { PolicyClaim } from './interface';

export const fetchDossierClaims = async (
  dossierId: string
): Promise<PolicyClaim[]> => {
  const url = new URL(`/app/v1/dossiers/${dossierId}/claims`, API_BASE_URL);
  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};

export const fetchClaimArtifacts = async (
  claimId: string
): Promise<Artifact[]> => {
  const url = new URL(`/app/v1/claims/${claimId}/artifacts`, API_BASE_URL);
  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};
